// LS = Local Storage
export const LS_CART_KEY = 'cart'
export const LS_CART_ID_KEY = 'cartId'

export function getProducts() {
  return JSON.parse(localStorage.getItem(LS_CART_KEY)) || []
}

export function normalizeProduct(product) {
  return {
    name: product.name,
    sku: product.sku,
    qty: product.qty,
    price: product.price,
    reference_price: product.reference_price,
    stock: product.stock,
    product_type: product.product_type,
    brand: product.brand,
    year: product.year,
    slug: product.slug,
    frontend_image: product.frontend_image,
  }
}

export function setProducts(products) {
  localStorage.setItem(
    LS_CART_KEY,
    JSON.stringify(products.map(normalizeProduct))
  )
}

export function getCartId() {
  return localStorage.getItem(LS_CART_ID_KEY)
}

export function setCartId(cartId) {
  return localStorage.setItem(LS_CART_ID_KEY, cartId)
}

export function findProduct(sku) {
  const products = getProducts()
  return products.find((product) => product.sku === sku)
}

export function upsertProduct(product) {
  let found = false
  const products = getProducts()
  products.forEach((_product, index) => {
    if (_product.sku === product.sku) {
      products[index].quantity = product.quantity
      found = true
    }
  })
  if (!found) {
    products.push(product)
  }
  setProducts(products)
  return found
}

export function removeProduct(sku) {
  const products = getProducts()
  const index = products.findIndex((product) => product.sku === sku)
  if (index === -1) return
  products.splice(index, 1)
  setProducts(products)
}

export function getProductsCount() {
  const products = getProducts()
  return products.reduce((acc, current) => acc + current.qty, 0)
}
// get total
